export const ProfileWhitelistRels = {
    GetProfileWhitelists: 'getProfileWhitelists',
    GetProfileWhitelist: 'getProfileWhitelist',
    CreateProfileWhitelistByPhone: 'createProfileWhitelistByPhone',
    CreateProfileWhitelistByCountryCode: 'createProfileWhitelistByCountryCode',
    DeleteProfileWhitelist: 'deleteProfileWhitelist',
    GetNonWhitelistedProfileStats: 'getNonWhitelistedProfileStats',
    FindNonWhitelistedProfiles: 'findNonWhitelistedProfiles',
    DeleteNonWhitelistedProfiles: 'deleteNonWhitelistedProfiles'
};
